import shimReady from "app/intlShim.js";

export default ["$stateProvider", "$injector", function routes($stateProvider, $injector) {
  $stateProvider
    .state('top', {
      url: "/{locale}?bypass",
      views: {
        "top": {
          template: require("./app.tpl.html")
        }
      },
      data: {
        isRoot: true
      },
      abstract: true,
      resolve: {
        intl: ["$q", function ($q) {
          return $q((resolve, reject) => {
            shimReady(() => {
              //console.log("intl shim loaded: ", window.Intl);
              resolve();
            });
          });
        }],
        config: ["ConfigService", "MaintenanceService", "$q", "$stateParams", "LocaleService", "AuthenticationService", function (ConfigService, MaintenanceService, $q, $stateParams, LocaleService, AuthenticationService) {
          var defer = $q.defer();
          ConfigService.loadConfig().then(() => LocaleService.loadStrings($stateParams.locale || "de-AT")).then(() => {            
            MaintenanceService.init();
            if (!$stateParams.locale) {
              AuthenticationService.renavigateToLogin();
            }
            defer.resolve();
          });
          return defer.promise;
        }],
      }
    })
    .state('app', {
      parent: "top",
      //url :"/",
      abstract: true,
      views: {
        top: {
          template: "<div ui-view=\"main\"/>"
        }
      },
      data: {
        anonymousAccess: false,
        showLoginClass: false
      },
      resolve: {
        user: ["AuthenticationService", "$q", function (AuthenticationService, $q) {
          return AuthenticationService.reloadUser().then((user) => {
            return $q.when(user);
          }, function () {
            return $q.when({});
          });
          //return $q.when({});
        }]
      }
    })
    .state('error', {
      parent: "app",
      url: "/error?title&message&key",
      data: {
        anonymousAccess: true,
        showLoginClass: true
      },
      views: {
        main: {
          template: require("./app/error/error-page.html"),
          controller: "ErrorPageController as controller"
        }
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/routes.js